import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PaymentData } from '../models/payment.interface';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  private apiUrl = `${environment.apiUrl}/payments`;

  constructor(private http: HttpClient) {}

  /**
   * Guarda los datos de un pago exitoso
   */
  saveSuccessfulPayment(paymentData: Partial<PaymentData>): Observable<any> {
    const payment: PaymentData = {
      ...paymentData,
      status: 'success',
      createdAt: new Date(),
      updatedAt: new Date()
    } as PaymentData;

    return this.http.post(`${this.apiUrl}`, payment);
  }

  /**
   * Guarda los datos de un pago fallido
   */
  saveFailedPayment(paymentData: Partial<PaymentData>): Observable<any> {
    const payment: PaymentData = {
      ...paymentData,
      status: 'error',
      createdAt: new Date(),
      updatedAt: new Date()
    } as PaymentData;

    return this.http.post(`${this.apiUrl}`, payment);
  }

  /**
   * Guarda los datos de un pago (genérico)
   */
  savePayment(paymentData: PaymentData): Observable<any> {
    return this.http.post(`${this.apiUrl}`, paymentData);
  }

  /**
   * Obtiene todos los pagos de un usuario
   */
  getUserPayments(userId: string): Observable<PaymentData[]> {
    return this.http.get<PaymentData[]>(`${this.apiUrl}/user/${userId}`);
  }

  /**
   * Obtiene un pago por ID
   */
  getPaymentById(paymentId: string): Observable<PaymentData> {
    return this.http.get<PaymentData>(`${this.apiUrl}/${paymentId}`);
  }

  /**
   * Actualiza el estado de un pago
   */
  updatePaymentStatus(paymentId: string, status: 'success' | 'error' | 'pending'): Observable<any> {
    return this.http.patch(`${this.apiUrl}/${paymentId}`, { 
      status, 
      updatedAt: new Date() 
    });
  }

  /**
   * Procesa un pago (método para compatibilidad con el componente existente)
   */
  processPayment(paymentData: any): Observable<any> {
    // Este método puede ser usado para procesar pagos a través del backend
    // Por ahora, retornamos un observable que simula el procesamiento
    return this.http.post(`${this.apiUrl}/process`, paymentData);
  }
}